<template>
  <div class="container">
    <div class="shop-inner-content row">
      <div class="loading-mask" :class="{ active: !dataIsLoad }"></div>
      <notice :custommarketid="CMID"></notice>
      <div class="info-content col-12 col-lg-5 order-1 order-lg-0">
        <Spec
          :dataisload="dataIsLoad"
          :selected="selectedData"
          :alldatas="itemDatas"
          :hasstock="hasStock"
          :btndescription="{
            default: '請選擇尺寸',
            addCart: 'ADD TO CART+',
            soldout: 'SOLD OUT',
            preshow: 'COMING SOON',
            notice: '索取貨到通知',
          }"
          v-on:change-selected="changeSelected"
          v-on:change-slideindex="changeNowSlideIndex"
          v-on:changecmid="handleCMID"
        />
      </div>
      <div class="photo-content col-12 col-lg-7 order-0 order-lg-1">
        <Photo
          :dataisload="dataIsLoad"
          :selected="selectedData"
          :alldatas="itemDatas"
          :changeImage="changePic"
        />
      </div>
      <div class="col-12 order-2">
        <div class="item-description">
          <h5 class="item-description-title">Description</h5>
          <div class="mb-2" v-html="itemDatas.Description"></div>
          <div v-html="itemDatas.MaterialDescription"></div>
        </div>
        <div class="item-other-info">
          <a @click.prevent="showSizeChart" class="collapsed" href="#">尺寸指南</a>
          <a @click.prevent="showWashChart" class="collapsed" href="#">洗滌說明</a>
          <a href="/notice">幫助</a>
        </div>
      </div>
      <div class="col-12 order-3">
        <Addon :marketID="CustomMarketID.substring(0, CustomMarketID.indexOf('CL'))" />
      </div>
      <div class="photo-content col-12 order-4">
        <Recommend :itemDatas="itemDatas" />
      </div>
      <SizeChart :dataisload="dataIsLoad" :alldatas="itemDatas" />
      <WashChart :dataisload="dataIsLoad" :alldatas="itemDatas" />
    </div>
  </div>
</template>

<script>
import Selector from '@page/common/js/template/select';

import Recommend from '@page/shopContent/components/Recommend';
import Spec from '@page/shopContent/components/Spec';
import Photo from '@page/shopContent/components/Photo';
import Addon from '@page/shopContent/components/Addon';
import WashChart from '@page/shopContent/components/WashPopup.vue';
import SizeChart from '@page/shopContent/components/sizeChart';
import Notice from '@page/shopContent/components/notice';
import axios from 'axios';
import { fireShopContentView } from '@global/gtm/product';

export default {
  data() {
    return {
      itemDatas: {},
      selectedDataID: null,
      selectedData: {},
      dataIsLoad: false,
      nowSlideIndex: 0,
      hasStock: false,
      CMID: null,
      changePic: false,
      CustomMarketID: window.CustomMarketID,
    };
  },
  components: {
    Spec,
    SizeChart,
    Photo,
    Recommend,
    Notice,
    Selector,
    WashChart,
    Addon,
  },
  created() {
    this.getData();
  },
  watch: {
    selectedDataID() {
      this.getSelectedData();
    },
  },
  methods: {
    getData() {
      axios
        .get(API_URL.MARKET_CONTENT + '?CustomMarketID=' + window.CustomMarketID)
        .then((response) => {
          let res = response.data;
          if (res.Code === 200) {
            this.itemDatas = res.Response;
            this.selectedDataID = res.Response.ColorID;
            this.dataIsLoad = true;
            return res.Response;
          } else {
            // 導回首頁 ?
            AlertDialog.alert('系統忙線中,請稍後再試', function () {
              window.location.href = '/';
            });
          }
        })
        .then((res) => {
          fireShopContentView({
            affiliation: this.selectedData.Name,
            customMarketID: res.CustomMarketID,
            eventName: res.Events.length ? res.Events[0].Name : '',
            name: res.Name,
            price: res.EventPrice > 0 ? res.EventPrice : res.SellPrice,
          });
        });
    },
    handleCMID(val) {
      this.CMID = val;
    },
    checkHasStock() {
      var _this = this;
      _this.hasStock = false;
      _this.selectedData.Specs.forEach(function (element, index) {
        if (parseInt(element.Stock) !== 0) {
          _this.hasStock = true;
        }
      });
    },
    changeSelected(val) {
      this.selectedDataID = val;
      this.changePic = true;
    },
    changeNowSlideIndex(val) {
      this.nowSlideIndex = val;
    },
    getSelectedData() {
      var _this = this;
      this.itemDatas.Colors.forEach(function (element, index) {
        if (element.ID === _this.selectedDataID) {
          _this.selectedData = element;
        }
      });
      this.checkHasStock();
    },
    showSizeChart() {
      $('#modal-sizechart').modal('show');
    },
    showWashChart() {
      $('#modal-wash-popup').modal('show');
    },
  },
};
</script>
